import { render, staticRenderFns } from "./DefinirNovaSenha.vue?vue&type=template&id=52e6fd98&scoped=true&"
import script from "./DefinirNovaSenha.vue?vue&type=script&lang=ts&"
export * from "./DefinirNovaSenha.vue?vue&type=script&lang=ts&"
import style0 from "./DefinirNovaSenha.vue?vue&type=style&index=0&id=52e6fd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6fd98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCol,VContainer,VForm,VRow,VTextField})
